import React, { Fragment } from 'react';

import {
  Box as Wrapper,
  Icon,
  Menu,
  MenuList,
  MenuItem,
  MenuDivider,
  MenuButton,
} from '@tonic-ui/react';

const DropdownMenu = ({
  id,
  tabIndex = 0,
  menuList,
  selectedItem,
  onChange,
  menuButtonProps,
  menuListProps,
  isResponsive,
  truncateString = false,
  placement = 'bottom-end', // most of the dropdowns are right aligned so defaulting to bottom-end
}) => {
  const handleClick = (event, value) => {
    if (event?.key === 'Enter' || event?.type === 'click') {
      onChange(value);
    }
  };

  const conditionalProps = {
    textOverflow: 'ellipsis',
    maxWidth: '200px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  };

  return (
    <>
      {selectedItem ? (
        <Menu id={id} data-id={id} placement={placement}>
          <MenuButton
            variant="ghost"
            style={{ userSelect: 'text' }}
            data-id={`${id}-menuButton`}
            data-ux-id={`${id}-menuButton`}
            tabIndex={tabIndex}
            {...menuButtonProps}
          >
            {
              // This is the support-dropdown which will show icon on smaller screen
              isResponsive ? (
                <>
                  <Wrapper display={{ sm: 'block', md: 'none' }}>
                    <Icon icon="menu" size="6x" verticalAlign="top" />
                  </Wrapper>
                  <Wrapper
                    {...(truncateString && conditionalProps)}
                    display={{ sm: 'none', md: 'block' }}
                  >
                    {selectedItem?.label ? selectedItem.label : selectedItem}
                  </Wrapper>
                </>
              ) : (
                <Wrapper {...(truncateString && conditionalProps)}>
                  {selectedItem?.label ? selectedItem.label : selectedItem}
                </Wrapper>
              )
            }
          </MenuButton>
          <MenuList
            zIndex="2000"
            minWidth="100%"
            whiteSpace="nowrap"
            overflow="auto"
            {...menuListProps}
          >
            {menuList.map((menuItem) => (
              <Fragment key={`${id}-menuItemBox-${menuItem.value}`}>
                {menuItem.label === 'showMenuDivider' ? (
                  <MenuDivider />
                ) : (
                  <MenuItem
                    key={`${id}-menuItem-${menuItem.value}`}
                    data-id={`menuItem-${menuItem.value}`}
                    data-ux-id={`${id}-menuItem-${menuItem.value}`}
                    disabled={menuItem.disabled}
                    onClick={(e) => handleClick(e, menuItem)}
                    onKeyDown={(e) => handleClick(e, menuItem)}
                  >
                    {menuItem.label}
                  </MenuItem>
                )}
              </Fragment>
            ))}
          </MenuList>
        </Menu>
      ) : null}
    </>
  );
};

export default DropdownMenu;
